import { styled, Typography, AccordionSummary, Box, DialogProps, Dialog } from '@mui/material';
import { MaterialDesignContent } from 'notistack';

export const FormQuestionTypography = styled(Typography)(() => ({
  paddingRight: '200px',
  width: '100%',
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme: { palette } }) => ({
  backgroundColor: palette.mode === 'dark' ? '#18222B' : palette.common.white,
  borderBottom: `1px solid ${palette.divider}`,
  '&.Mui-expanded': {
    margin: 0,
    minHeight: 'var(--commonMinHeight)',
  },
  '.MuiAccordionSummary-content': {
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    },
  },
}));

export const DragOverPlaceholder = styled(Box)(({ theme: { palette } }) => ({
  width: '100%',
  height: '3px',
  backgroundColor: palette.primary.light,
  marginTop: '8px',
}));

interface DialogFullscreenProps extends DialogProps {
  isFullscreen?: boolean;
  isDataAbsent?: boolean;
}

export const DialogFullscreen = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'isFullscreen' && prop !== 'isDataAbsent',
})<DialogFullscreenProps>(({ isFullscreen, isDataAbsent }) => ({
  display: isDataAbsent ? 'none' : 'block',
  '.MuiDialog-paper': {
    maxWidth: isFullscreen ? 'calc(100vw - var(--dialogBorderGap))' : 'var(--dialogRegularWidth)',
    width: isFullscreen ? 'calc(100vw - var(--dialogBorderGap))' : 'var(--dialogRegularWidth)',
  },
}));

export const FormFieldsetContainer = styled('fieldset')(() => ({
  height: '100%',
}));

export const StyledMaterialDesignContent = styled(MaterialDesignContent)(({ theme: { palette } }) => ({
  '&.notistack-MuiContent-success': {
    border: '2px solid #82CD19',
    backgroundColor: palette.mode === 'dark' ? '#000D1A' : '#fff',
    color: palette.text.primary,
  },
  '&.notistack-MuiContent-error': {
    border: '2px solid #EF5060',
    backgroundColor: palette.mode === 'dark' ? '#000D1A' : '#fff',
    color: palette.text.primary,
  },
}));
